module.exports = __webpack_public_path__ + "static/img/2.70636158.png";